module.exports = __webpack_public_path__ + "landing_slider_third_slide_1440x900.3e96f21.jpg";